import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { CashRegister, CashRegisterModel } from '@/store/types/work/CashRegister';

export const NAMESPACE = 'work/enterprises/cashRegisters';

const state: RootState = {
  status: null,
  items: [],
  item: {},
  meta: undefined
};

const getters: GetterTree<RootState, any> = {
  items: state => state.items,
  meta: state => state.meta,
  loading: state => state.status === null,
  status: state => state.status,
  item: state => state.item
};

const actions: ActionTree<RootState, any> = {
  request: ({ commit, dispatch, rootGetters }:any, filter:any = {}) => {
    filter = { 'filters[order_by]': 'title', ...filter };
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise.id}/cash_registers`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  show: ({ commit, state, rootGetters }:any, id:number) => {
    state.items.forEach((c:CashRegister) => {
      if (c.id === id) {
        commit('item', c);
      }
    });
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({
      url: `enterprise/${enterprise.id}/cash_registers/${id}`
    })
      .then((resp:any) => {
        commit('successShow', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  }
};

const mutations: MutationTree<RootState> = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state, resp) => {
    state.status = true;
    if (resp.data) {
      state.items = [];
      resp.data.forEach((item: CashRegister) => {
        state.items.push(new CashRegisterModel(item));
      });
    }
    state.meta = resp.meta;
  },
  successShow: (state:any, resp:any) => {
    state.status = true;
    state.item = new CashRegisterModel(resp.data);
    state.meta = resp.meta;
  },
  setItem: (state:any, resp:any) => {
    state.item = resp.data;
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
